// Generated by apps/backend/scripts/sync-toast-menu-images-to-r2.mjs on 2026-10-29
// from the Toast menu published 2026-10-29T15:56:22.625+0000. Do not edit by hand.
//
// Kept apart from toast-menu-images.ts so the /menu route's head() can use the
// banner without pulling the photo table into the entry chunk.

export const TOAST_MENU_MEDIA = {
  "banner": "https://pub-32df7c4bc29843a79abbd70027a66e60.r2.dev/toast-menu/2026-10-29/menu-banner-cdf848b1-1200x630.jpg"
} as const
